import React, {Component} from "react";


class InputSelect extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}}
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.props.onChange(e);
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        return (
            <React.Fragment>
            {this.props.blockItem.isReadOnly &&
                <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                    {this.props.blockItem.isDisplayInfoText &&
                    <div id={"coreBlockItem-itemInfo-" + this.props.blockItem.id}
                         className="coreBlockItem-itemInfo">i</div>
                    }
                    {this.props.blockItem.options.map(option => (
                        <React.Fragment>
                            {option.value == this.state[name] && <input type="text"
                                        className="coreBlockItem-input coreBlockItem-typeText"
                                        autoComplete="off"
                                        name={name}
                                        value={option.label}
                                        onChange={this.change}
                                        readOnly={this.props.blockItem.isReadOnly}/>
                            }
                        </React.Fragment>
                    ))}
                </div>
            }
            {!this.props.blockItem.isReadOnly &&
                <div className="coreBlockItem-value" style={JSON.parse(this.props.blockItem.inputCss)}>
                    {this.props.blockItem.isDisplayInfoText &&
                    <div id={"coreBlockItem-itemInfo-" + this.props.blockItem.id}
                         className="coreBlockItem-itemInfo">i</div>
                    }
                    <select id={"BLOCK_ITEM_DATASOURCE" + this.props.blockItem.datasourceId}
                            className="coreBlockItem-input coreBlockItem-typeSelect"
                            name={name}
                            value={this.state[name]}
                            onChange={this.change}
                            readOnly={this.props.blockItem.isReadOnly}>
                        {this.props.blockItem.emptyValue !== "NONE" &&
                        <option value={this.props.blockItem.emptyValue}>{this.props.blockItem.emptyLabel}</option>
                        }
                        {this.props.blockItem.options.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
            }
            </React.Fragment>
        );
    }
}

export default InputSelect;